module.exports = __webpack_public_path__ + "img/banner_new_9.c3821e3c.jpg";